import React from 'react'
import styled from 'styled-components'

import { Overlay } from '../../../details-client/Overlay'

const StyledContent = styled.div`
  @media screen and (min-width: 1024px) {
    width: 760px;
  }
`

const StyledIFrame = styled.iframe`
  height: 100%;
  width: 100%;
`

class BaggageFeeOverlay extends React.Component {
  render() {
    const {
      url = 'https://www.priceline.com/help/#/faq/ext(air_phone_list)',
      mobileBreakpoint = 1024,
      isOpen = false,
      onClose,
      headerColor = 'background.lightest',
    } = this.props
    const title = 'Baggage Fee'
    const content = (
      <StyledContent>
        <StyledIFrame src={url} />
      </StyledContent>
    )

    return (
      isOpen && (
        <Overlay
          content={content}
          header={title}
          showHeaderTitle={true}
          onClose={onClose}
          mobileBreakpoint={mobileBreakpoint}
          headerColor={headerColor}
          fullScreenOnMobile={true}
        />
      )
    )
  }
}

export { BaggageFeeOverlay }
